var SENTRY_RELEASE;SENTRY_RELEASE={name: "Forbruger", version: "1.0.3"};